import { IUserRegisterVerifyPin } from '../../../entity/interface/iSubscription';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IUserRegisterVerifyPinUseCase {
    execute(language: string, payload: IUserRegisterVerifyPin, apiToken: { [key: string]: string }): Promise<any>;
}

export class UserRegisterVerifyPinUseCase implements IUserRegisterVerifyPinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        language: string,
        payload: IUserRegisterVerifyPin,
        apiToken: { [key: string]: string }
    ): Promise<any> {
        return await this.subscriptionRepository.userRegisterVerifyPin(language, payload, apiToken);
    }
}
